
//importaciones de paquetes

import { CustomAutocomplete } from 'common'

//importaciones de componentes
import { Button, Divider, FormControl, Grid, TextField } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

const ModalPreInventory = ({useFetchInit}) =>{

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,

        defaultData,
        
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { modalOpeningMode} = globalStates

    // ------------------------------------------------ actions
    const { handleClickCloseModal, onSubmitFormPreInventory } = Actions

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormPreInvventory:{formState, onInputChange} } = Forms
    

    return(
        <>
            <form onSubmit={onSubmitFormPreInventory}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth> 
                            <label htmlFor="marca">* Marca</label>
                            <TextField
                                id='marca'
                                name='marca'
                                value={ formState.marca }
                                onChange={ onInputChange }
                                size='small'
                                placeholder='Marca'
                                hiddenLabel
                                type='text'
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="modelo">* Modelo</label>
                            <TextField
                                id='modelo'
                                name='modelo'
                                value={ formState.modelo }
                                onChange={ onInputChange }
                                size='small'
                                placeholder='Modelo'
                                hiddenLabel
                                type='text'
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="linea">* Linea</label>
                            <TextField
                                id='linea'
                                name='linea'
                                size='small'
                                type='text'
                                placeholder='Linea'
                                hiddenLabel
                                value={ formState.linea }
                                onChange={ onInputChange }
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="color">* Color</label>
                            <TextField
                                id='color'
                                name='color'
                                size='small'
                                type='text'
                                placeholder='Color'
                                hiddenLabel
                                value={ formState.color }
                                onChange={ onInputChange }
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="chasis">* No. Chasis</label>
                            <TextField
                                id='chasis'
                                name='chasis'
                                value={ formState.chasis }
                                onChange={ onInputChange }
                                placeholder='No. Chasis'
                                size='small'
                                hiddenLabel     
                                type='text'
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="matricula">* Matricula</label>
                            <TextField
                                id='matricula'
                                name='matricula'
                                value={ formState.matricula }
                                onChange={ onInputChange }
                                placeholder='Matricula'
                                size='small'
                                hiddenLabel     
                                type='text'
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="valor">* Valoracion del Vehiculo (Q) </label>
                            <TextField
                                id='valor'
                                name='valor'
                                value={ formState.valor }
                                onChange={ onInputChange }
                                placeholder='Valor'
                                size='small'
                                hiddenLabel     
                                type='text'
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Divider />

                <div className="border-bottom border-secondary "></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button 
                                startIcon={<ArrowLeftCircle/>}
                                variant="contained"
                                type="button" 
                                className='btn-round'
                                color='warning'
                                onClick={() => handleClickCloseModal(false, 'EDIT')} 
                                sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                            >
                                Volver
                            </Button>

                            {(modalOpeningMode==='EDITABLE') && (
                                <Button
                                    endIcon={<ArrowRightCircle/>}
                                    variant="contained"
                                    type="submit"
                                    className='btn-round'
                                    color='primary'
                                    sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                                >
                                    Guardar
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
export{
    ModalPreInventory
}